import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  drawerAwareContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
    overflowY: "auto",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
  },
  titleText: {
    color: colorsConstants.primaryText,
    fontSize: 24,
    textAlign: "center",
    flex: 1,
  },
  tabsContainer: {
    borderRadius: "12px",
    overflow: "hidden",
    border: "1px solid rgba(0,0,0,0.08)",
  },
  selectedTab: {
    padding: "24px",
  },
  sectionTitle: {
    color: colorsConstants.primaryText,
    fontSize: 18,
    fontWeight: 600,
    marginBottom: "16px",
  },
  searchBox: {
    marginBottom: "16px",
  },
  userListItem: {
    borderRadius: "8px",
    marginBottom: "4px",
  },
  relatedUsersContainer: {
    marginLeft: "24px",
    marginTop: "4px",
    marginBottom: "8px",
    borderLeft: "2px solid rgba(25,118,210,0.3)",
    paddingLeft: "12px",
  },
  relatedUserItem: {
    borderRadius: "8px",
    marginBottom: "2px",
    paddingTop: "4px",
    paddingBottom: "4px",
  },
  relatedActionsRow: {
    display: "flex",
    gap: "8px",
    marginTop: "8px",
    marginBottom: "4px",
    flexWrap: "wrap",
  },
  roleChip: {
    marginLeft: "8px",
  },
  stagedCardsContainer: {
    marginTop: "16px",
  },
  stagedCard: {
    padding: "16px",
    borderRadius: "10px",
    border: "1px solid rgba(0,0,0,0.08)",
    marginBottom: "12px",
    position: "relative",
  },
  stagedCardTitle: {
    fontWeight: 600,
    fontSize: 15,
    color: colorsConstants.primaryText,
  },
  stagedCardSubtitle: {
    fontSize: 13,
    color: "text.secondary",
    marginTop: "2px",
  },
  removeCardButton: {
    position: "absolute",
    top: "8px",
    right: "8px",
  },
  addButtonsRow: {
    display: "flex",
    gap: "12px",
    marginBottom: "8px",
    flexWrap: "wrap",
  },
  saveButtonRow: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "24px",
  },
  dialogField: {
    marginTop: "16px",
  },
  passwordRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
  },
  passwordField: {
    flex: 1,
  },
  parentLinkSection: {
    marginTop: "8px",
  },
  parentLinkTitle: {
    fontSize: 13,
    color: "text.secondary",
    marginBottom: "8px",
  },
  noItemsText: {
    color: "text.secondary",
    fontSize: 14,
    marginTop: "8px",
  },
  warningText: {
    color: "warning.main",
    fontSize: 13,
    marginTop: "8px",
  },
  pickerSearchBox: {
    marginBottom: "8px",
    marginTop: "8px",
  },
  pickerList: {
    maxHeight: "220px",
    overflowY: "auto",
    border: "1px solid rgba(0,0,0,0.1)",
    borderRadius: "8px",
  },
  pickerListItem: {
    borderRadius: "6px",
  },
  dialogTabsContainer: {
    marginBottom: "16px",
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
